"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableContext = void 0;

var react_1 = require("react");

exports.TableContext = (0, react_1.createContext)({
  isAlternating: false,
  hasHighlights: false,
  hasActions: false
});